import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiFetch } from '@/api/client';
import { ErrorNote, SubmitButton } from '@/components/ui';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setError(new Error('The two passwords do not match'));
      return;
    }
    setPending(true);
    setError(null);
    try {
      await apiFetch('/api/auth/reset-password', { method: 'POST', body: { token, password }, anonymous: true });
      setDone(true);
    } catch (err) {
      setError(err);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-sm">
        {done ? (
          <div className="card space-y-3 p-6">
            <h1 className="text-lg font-semibold">Password updated</h1>
            <p className="text-sm text-slate-600">You can sign in with your new password now.</p>
            <Link to="/login" className="btn-primary w-full">Go to sign in</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="card space-y-4 p-6">
            <h1 className="text-lg font-semibold">Set a new password</h1>
            {!token && <ErrorNote error={new Error('This link is missing its token. Request a new reset email.')} />}
            <ErrorNote error={error} />
            <div>
              <label className="label" htmlFor="pw">New password</label>
              <input id="pw" type="password" className="input" required minLength={10} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
              <p className="mt-1 text-xs text-slate-500">At least 10 characters, with upper case, lower case and a digit.</p>
            </div>
            <div>
              <label className="label" htmlFor="pw2">Confirm password</label>
              <input id="pw2" type="password" className="input" required autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            <SubmitButton pending={pending} disabled={!token} className="btn-primary w-full">Set password</SubmitButton>
          </form>
        )}
      </div>
    </div>
  );
}
